import { Alert, CardContent } from '@mui/material';
import React, { useState } from 'react';
import { createUserProject } from '../../../modules/project';
import Modal from '../../elements/Modal';
import UserProjectForm from './UserProjectForm';
import { useNotification } from '../../../hooks/NotificationContext';
import { useNavigate } from 'react-router-dom';
import { useInvalidateQuery } from '../../../query/apiQueries';

const AddUserProject = ({ open, setOpen }) => {
  const [error, setError] = useState(null);
  const { addNotification } = useNotification();
  const navigate = useNavigate()
  const currentUserId = JSON.parse(localStorage.getItem('user'))?.id;
  const initialValues = {
    name: '',
    description: '',
    reviewWorkflow: false,
    mandatoryAssignedTo: false,
    defaultAssignedTo: currentUserId,
  };
  const invalidateQueries = useInvalidateQuery();

  const handleClose = () => {
    setOpen(false);
    setError(null);
  };

  const handleSave = async (values) => {
    let project = {
      ...values,
    };
    try {
      const response = await createUserProject(project);
      addNotification('success', 'Project added successfully! Redirecting to project dashboard...');
      handleClose();

      invalidateQueries([
        { key: 'project', type: 'headerProjects' },
        { key: 'project', type: 'dashboardProjects' },
        { key: 'project', type: 'list' },
      ]);
      if (response?.id) {
        setTimeout(() => {
          navigate(`/project/${response.id}/dashboard`);
        }, 1000);
      }
    } catch (error) {
      setError(error.message || 'Failed to add project. Please try again.');
    }
  };

  return (
    <>
      <Modal
        open={open}
        width="md"
        modalTitle="Add Project"
        handleClose={handleClose}
        disableEscapeKeyDown>
        <CardContent sx={{ pt: 0 }}>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <UserProjectForm
            initialValues={initialValues}
            onSubmit={handleSave}
          />
        </CardContent>
      </Modal>
    </>
  );
};

export default AddUserProject;
